export const contentWrapperBorderRadius = '8px';

export const contentWrapperMinWidth = '140px';
